import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../common/breadcrumb";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getSingleOrderList } from '../../redux/actions/OrderActions';
import Table from 'react-bootstrap/Table';
// singleorderlist
import { Modal, Button, Card, CardBody, CardHeader, Col, Container, Form, FormGroup, Input, Label, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import DataTables from "../common/DataTables";
import moment from "moment/moment";
function OrderCustomerDetails() {
    let { id } = useParams();


    const { singleorderlist } = useSelector(state => state.orders);

    const [item, setItem] = useState([]);




    const dispatch = useDispatch();

    const [detaillist, setdetaillist] = useState([])

    const Capitalize = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };


    const rowTotal = (row) => {

        if (row?.total % 1 !== 0) {
            return row?.total
        } else {
            return row?.total?.toFixed(2)
        }

    }


    var columns = [
        {
            name: <b>{Capitalize("S.No")}</b>,
            header: <b>{Capitalize("S.No")}</b>,
            cell: (row, index) => index + 1,
            width: "100px",
        },
        {
            name: <b>{Capitalize("Image")}</b>,
            header: <b>{Capitalize("Image")}</b>,
            cell: (row, index) => (
                <>
                    <span>
                        <img style={{ width: 40, height: 40 }} src={row?.image}></img>
                    </span>
                </>

            )
        },
        {
            name: <b>{Capitalize("Name")}</b>,
            header: <b>{Capitalize("Name")}</b>,
            selector: row => `${row?.name}(${row?.variant?.name})`,
            style: {
                textAlign: "center",
            },
            width: "500px",
        },
        {
            name: <b>{Capitalize("Category")}</b>,
            header: <b>{Capitalize("Category")}</b>,
            selector: row => row?.category?.name,
            style: {
                textAlign: "center",
            },
            width: "400px",
        },
        // {
        //     name: <b>{Capitalize("Sub Category")}</b>,
        //     header: <b>{Capitalize("Sub Category")}</b>,
        //     selector: row => row?.subCategory
        //         ?.name,
        //     style: {
        //         textAlign: "center",
        //     },
        // },
        {
            name: <b>{Capitalize("qty")}</b>,
            header: <b>{Capitalize("qty")}</b>,
            selector: row => row?.qty,
            style: {
                textAlign: "center",
            },
        },
        // {
        //     name: <b>{Capitalize("price")}</b>,
        //     header: <b>{Capitalize("price")}</b>,
        //     selector: row => row?.price,
        //     style: {
        //         textAlign: "center",
        //     },
        // },
        // {
        //     name: <b>{Capitalize("costPrice")}</b>,
        //     header: <b>{Capitalize("costPrice")}</b>,
        //     selector: row => row?.costPrice,
        //     style: {
        //         textAlign: "center",
        //     },
        // },
        // {
        //     name: <b>{Capitalize("razorPayId")}</b>,
        //     header: <b>{Capitalize("razorPayId")}</b>,
        //     selector: row => row?.razorPayId,
        //     style: {
        //         textAlign: "center",
        //     },
        // },
        {
            name: <b>{Capitalize("Price")}</b>,
            header: <b>{Capitalize("Price")}</b>,
            selector: row => parseFloat(row?.price).toFixed(2),
            style: {
                textAlign: "center",
            },
        },
        // {
        //     name: <b>{Capitalize("orderStatus")}</b>,
        //     header: <b>{Capitalize("orderStatus")}</b>,
        //     selector: row => row?.orderStatus,
        //     style: {
        //         textAlign: "center",
        //     },
        // },



    ];

    // useEffect(() => {
    // if(singleorderlist){
    //     setdetaillist[singleorderlist.itemDetails]
    // }
    // }, [singleorderlist])


    useEffect(() => {
        if (id) {
            dispatch(getSingleOrderList(id))
        }
    }, [id])
    // console.log({ singleorderlist })

    if (!singleorderlist) {
        return <>loading...</>
    }
    return (
        <Fragment>
            <Breadcrumb title="Order Details" parent="Digital" />
            <Container fluid={true}>

                <Col xl="12">


                    <Card>
                        <Row xl={"2"}>
                            <Col xl={"6"}>
                                <div>
                                    <CardHeader>
                                        <h5>Billing Address</h5>
                                    </CardHeader>
                                    <CardBody>
                                        <div className="profile-table">
                                            <p style={{ fontWeight: "bold", marginBottom: "8px" }}>
                                                {singleorderlist?.billingAddress?.first_name} {singleorderlist?.billingAddress?.last_name}
                                                {singleorderlist?.billingAddress?.address_type && ` (${Capitalize(singleorderlist?.billingAddress?.address_type)})`}
                                            </p>
                                            <p style={{ marginBottom: "8px", lineHeight: "1.6" }}>
                                                {[
                                                    singleorderlist?.billingAddress?.address,
                                                    singleorderlist?.billingAddress?.location,
                                                    singleorderlist?.billingAddress?.state,
                                                    singleorderlist?.billingAddress?.country,
                                                    singleorderlist?.billingAddress?.pincode
                                                ].filter(Boolean).join(", ")}
                                            </p>
                                            <p style={{ marginBottom: "4px" }}>
                                                <strong>Mobile:</strong> {singleorderlist?.billingAddress?.mobile}
                                            </p>
                                            {/* <p style={{ marginBottom: "4px" }}>
                                                <strong>Email:</strong> {singleorderlist?.customer?.email}
                                            </p> */}
                                            {singleorderlist?.billingAddress?.comments && (
                                                <p style={{ marginBottom: "4px" }}>
                                                    <strong>Comments:</strong> {singleorderlist?.billingAddress?.comments}
                                                </p>
                                            )}
                                        </div>
                                    </CardBody>
                                </div>
                                <div>
                                    <CardHeader>
                                        <h5>Shipping Address</h5>
                                    </CardHeader>
                                    <CardBody>
                                        <div className="profile-table">
                                            <p style={{ fontWeight: "bold", marginBottom: "8px" }}>
                                                {singleorderlist?.shippingAddress?.first_name} {singleorderlist?.shippingAddress?.last_name}
                                                {singleorderlist?.shippingAddress?.address_type && ` (${Capitalize(singleorderlist?.shippingAddress?.address_type)})`}
                                            </p>
                                            <p style={{ marginBottom: "8px", lineHeight: "1.6" }}>
                                                {[
                                                    singleorderlist?.shippingAddress?.address,
                                                    singleorderlist?.shippingAddress?.location,
                                                    singleorderlist?.shippingAddress?.state,
                                                    singleorderlist?.shippingAddress?.country,
                                                    singleorderlist?.shippingAddress?.pincode
                                                ].filter(Boolean).join(", ")}
                                            </p>
                                            <p style={{ marginBottom: "4px" }}>
                                                <strong>Mobile:</strong> {singleorderlist?.shippingAddress?.mobile}
                                            </p>
                                            {/* <p style={{ marginBottom: "4px" }}>
                                                <strong>Email:</strong> {singleorderlist?.customer?.email}
                                            </p> */}
                                            {singleorderlist?.shippingAddress?.comments && (
                                                <p style={{ marginBottom: "4px" }}>
                                                    <strong>Comments:</strong> {singleorderlist?.shippingAddress?.comments}
                                                </p>
                                            )}
                                        </div>
                                    </CardBody>
                                </div>
                            </Col>
                            <div>
                                <CardHeader>
                                    <h5>Order Information</h5>
                                </CardHeader>
                                <CardBody>

                                    <div className="table-responsive profile-table">
                                        <Table className="table-responsive">
                                            <tbody>
                                                <tr>
                                                    <td>Order Date</td>
                                                    <td>{moment(singleorderlist?.orderDate, "YYYY-MM-DD").format("DD-MM-YYYY")}</td>
                                                </tr>
                                                <tr>
                                                    <td>Order Status:</td>
                                                    <td>{singleorderlist?.orderStatus[0]?.toUpperCase() + singleorderlist?.orderStatus?.slice(1)}</td>
                                                </tr>
                                                {/* <tr>
                                                    <td>Store Name:</td>
                                                    <td>{singleorderlist?.storeName ? singleorderlist?.storeName : "-"}</td>
                                                </tr> */}
                                                <tr>
                                                    <td>Payment Type</td>
                                                    <td>{singleorderlist?.paymentType?.toUpperCase()}</td>
                                                </tr>
                                                <tr>
                                                    <td>Payment Status</td>
                                                    <td>{singleorderlist?.paymentStatus[0]?.toUpperCase() + singleorderlist?.paymentStatus?.slice(1)}</td>
                                                </tr>
                                                {singleorderlist?.paymentType?.toLowerCase() === "online" && <tr>
                                                    <td>Transaction Id:</td>
                                                    <td>{singleorderlist?.payment_id}</td>
                                                </tr>}
                                                <tr>
                                                    <td>Sub Total:</td>
                                                    <td>₹ {parseFloat(singleorderlist?.subTotal).toFixed(2)}</td>
                                                </tr>
                                                <tr>
                                                    <td>Discount:</td>
                                                    <td>₹ {parseFloat(singleorderlist?.discount).toFixed(2)}</td>
                                                </tr>
                                                <tr>
                                                    <td>Delivery Charge:</td>
                                                    <td>₹ {parseFloat(singleorderlist?.delivery_charge).toFixed(2)}</td>
                                                </tr>
                                                <tr>
                                                    <td>Tax:</td>
                                                    <td>₹ {singleorderlist?.tax && singleorderlist?.tax?.toFixed(2)}</td>
                                                </tr>
                                                <tr>
                                                    <td>Total:</td>
                                                    <td>₹ {singleorderlist?.total && singleorderlist?.total?.toFixed(2)}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>

                                </CardBody>
                            </div>

                        </Row>

                    </Card>
                </Col>
                <Row />


                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader>
                                <h5>Item Details</h5>
                            </CardHeader>
                            <CardBody>

                                <div className="clearfix"></div>
                                <div id="basicScenario" className="product-physical">
                                    <Fragment>
                                        <DataTables
                                            columns={columns}
                                            row={singleorderlist?.itemDetails
                                                ? singleorderlist?.itemDetails : []}
                                        />

                                    </Fragment>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>


            </Container>

        </Fragment>
    )
}

export default OrderCustomerDetails